import type { SchemaInput } from './schema-input.js';
import { isString } from './runtime-values.js';

export const SIGNIN_SOURCES = new Set(['account', 'save', 'map_library', 'map_assistant', 'share', 'upgrade', 'signin_page', 'unknown']);
export const SIGNIN_METHODS = new Set(['google', 'email']);
export const SIGNIN_EVENT_PROPS = {
  signin_source: SIGNIN_SOURCES,
  method: SIGNIN_METHODS,
  tracking_version: new Set(['1']),
};

export function signinEventProps<Common extends Record<string, Set<string> | RegExp>>(common: Common) {
  return {
    signin_dialog_opened: { ...common, ...SIGNIN_EVENT_PROPS },
    signin_started: { ...common, ...SIGNIN_EVENT_PROPS },
    signin_returned: { ...common, ...SIGNIN_EVENT_PROPS },
    signin_page_viewed: { ...common, ...SIGNIN_EVENT_PROPS },
  };
}

export function signinSource(value: SchemaInput): string {
  return isString(value) && SIGNIN_SOURCES.has(value) ? value : 'unknown';
}
